module.exports = __webpack_public_path__ + "static/media/banner.64315502.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner.jpeg
// module id = 509
// module chunks = 1